module.exports = __webpack_public_path__ + "img/41.37d73a35.png";